import { create } from 'zustand';
import { ConfigurationNew } from './services/configManagerNew';

type Store = {
  configuration: ConfigurationNew | null;
  setConfiguration: (v: ConfigurationNew) => void;
};

export const useStore = create<Store>((set) => ({
  configuration: null,
  setConfiguration: (configuration) => set({ configuration }),
}));
